import { compact } from 'lodash';
import createSagaMiddleware from 'redux-saga';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();

export { default as rootReducer } from './ducks';

export const areDevToolsEnabled = () => !__IS_TEST__ && __ENV__ !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION__;

export const runSagaMiddleware = () => {
  sagaMiddleware.run(rootSaga);
};

export const middleware = [sagaMiddleware];

export const enhancers = compact([areDevToolsEnabled() && window.__REDUX_DEVTOOLS_EXTENSION__()]);
